import React, { Component } from 'react'
import { connect } from 'react-redux'
import { logoutUser } from 'redux/actions/authActions'
import { deleteFilterValue, getFilter, resetDagState } from 'redux/actions/dagActions'
import { setDataTables } from 'redux/actions/dataTablesActions'

import { withStyles } from '@material-ui/styles'
import AccessDenied from 'components/common/AccessDenied'
import PropTypes from 'prop-types'
import { Theme } from 'utils/Theme'
import Header from 'components/layout/Partials/Header'
import { NavLink } from 'react-router-dom'
import Loading from 'components/common/Loading'
import AdminLayout from 'components/layout/AdminLayout'

import moment from 'moment'
import * as Icon from 'react-feather'
import DataTable from 'react-data-table-component'
import { dagResync } from 'components/common/Notfications'
import TextFieldGroup from 'components/common/TextFieldGroup'
import TableActions from './Partials/TableActions'
import SecureImage from 'components/common/SecureImage';

const styles = Theme()

class ViewFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: {},
      loading: true,
      errors: {},
      filterValues: null,
      search_input: null,
      toDelete: null,
    }
    this.updateTablePage = this.updateTablePage.bind(this)
    this.updateTableRows = this.updateTableRows.bind(this)
    this.confirmDelete = this.confirmDelete.bind(this)
    this.onChange = this.onChange.bind(this)
    this.columns = [
      {
        name: 'Logo',
        width: '100px',
        cell: row => <div>{row.logo && <SecureImage alt={'Logo'} source={`/api/uploads/${row.logo}`} height={24} />}</div>,
        sortable: false,
      },
      {
        name: 'Unique ID',
        selector: 'identifier',
        sortable: true,
      },
      {
        name: 'Title',
        selector: 'title',
        sortable: true,
      },
      {
        name: 'Users',
        cell: row => <div>{row['user-filter-values']?.length}</div>,
      },
      {
        name: 'Created',
        cell: row => <div>{moment(row.date).format('Do MMM YYYY')} </div>,
        sortable: false,
      },
      {
        name: 'Actions',
        width: '350px',
        cell: row => (
         <TableActions row={row} onDelete={() => this.setState({ toDelete: row._id })} />
        ),
        sortable: false,
      },
    ]
  }

  componentDidMount() {
    const filter = this.props.match.params.id
    this.props.getFilter(filter)
  }

  componentWillUnmount() {
    this.props.resetDagState()
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let { filterValues, search_input } = prevState
    const { dag } = nextProps
    if (dag && dag.filter && search_input === null) {
      if (dag.filter['filter-values']) {
        filterValues = dag.filter['filter-values']
      }
    }
    return { filterValues }
  }

  updateTablePage = (page, tableName) => {
    const tables = this.props.dataTables
    tables[tableName] = {
      page,
      rows: tables[tableName] !== undefined ? tables[tableName].rows : 20,
    }
    this.props.setDataTables(tables)
  }
  updateTableRows = (page, rows, tableName) => {
    const tables = this.props.dataTables
    tables[tableName] = {
      page,
      rows,
    }
    this.props.setDataTables(tables)
  }
  confirmDelete = () => {
    this.props.deleteFilterValue(this.state.toDelete,  this.props.match.params.id)
    this.setState({toDelete: null})
  }

  onChange(event) {
    const search_input = event.target.value

    this.setState({ [event.target.name]: event.target.value })

    const filterValues = this.props.dag.filter['filter-values']

    let updatedFilterValuesList = filterValues.filter(function (item) {
      return (
        item.identifier.toLowerCase().search(search_input.toLowerCase()) !== -1 ||
        item.title.toLowerCase().search(search_input.toLowerCase()) !== -1 ||
        item.description.toLowerCase().search(search_input.toLowerCase()) !== -1
      )
    })

    this.setState({ filterValues: updatedFilterValuesList })
  }

  render() {
    const { classes, auth, dataTables, history, dag } = this.props
    const { toDelete, filterValues, search_input } = this.state
    var defaultPage = 1
    var rowsPerPage = 20
    if (dag.filter && dataTables.tables) {
      if (dataTables.tables[`filter-${dag.filter.title}`]) {
        defaultPage = dataTables.tables[`filter-${dag.filter.title}`].page
        rowsPerPage = dataTables.tables[`filter-${dag.filter.title}`].rows
      }
    }

    return (
      <AdminLayout>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">
              Filter `&gt;` <span className={'u-text-muted'}> {dag.filter ? dag.filter.title : ''}</span>
            </h2>
          </Header>
          {auth.isAuthenticated && auth.user.role === 'Admin' ? (
            <div className="u-m-xsmall">
              <div className={'row'}>
                {dagResync(classes)}
                <div className="col-md-12 col-sm-12 col-xl-12 u-mb-medium">
                  <div className="u-m-auto">
                    {dag.loading === true || dag.filter === null || dag.filter === undefined ? (
                      <Loading />
                    ) : (
                      <div className="c-card u-p-zero u-m-zero">
                        <div className="o-line c-card__title u-p-small u-m-small">
                          <h4 className={`c-card__title ${classes.colorSecondary}`}>{dag.filter.title}</h4>
                          <div className="c-dropdown dropdown">
                            <span
                              className={`c-btn ${classes.buttonPrimary} has-icon dropdown-toggle`}
                              id="MoreActionsDropdown"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              More Actions
                            </span>

                            <div
                              className="c-dropdown__menu dropdown-menu has-arrow dropdown-menu-right"
                              aria-labelledby="MoreActionsDropdown"
                            >
                              <div
                                onClick={() => {
                                  history.goBack()
                                }}
                                className="c-dropdown__item dropdown-item"
                              >
                                Back
                              </div>
                              <NavLink
                                to={`/settings/dag/filter-values/${dag.filter._id}/create`}
                                className="c-dropdown__item dropdown-item"
                              >
                                New {dag.filter.title}
                              </NavLink>
                              <NavLink to={`/settings/dag/filters`} className="c-dropdown__item dropdown-item">
                                Filters
                              </NavLink>
                              <NavLink to={`/settings/dag/dynamic-apps`} className="c-dropdown__item dropdown-item">
                                Dynamic Apps
                              </NavLink>
                              <NavLink to={`/settings/dag/master-apps`} className="c-dropdown__item dropdown-item">
                                Master Apps
                              </NavLink>
                            </div>
                          </div>
                        </div>

                        <div className={'row'}>
                          <div className={'col-12'}>
                            <div className={'c-tabs__content tab-content'}>
                              <div className={' o-line u-p-small'}>
                                <TextFieldGroup
                                  label={`Search ${dag.filter.title}`}
                                  onChange={this.onChange}
                                  name={'search_input'}
                                  value={search_input || ''}
                                  placeholder={'Search | ID | Title | Description'}
                                />
                              </div>
                              {dag.filter['filter-values'] === undefined
                                ? ''
                                : dag.filter['filter-values'].length > 0 && (
                                    <div className="c-table-responsive@tablet">
                                      {toDelete === null ? (
                                        <DataTable
                                          title=""
                                          responsive={false}
                                          // striped={true}
                                          // dense
                                          columns={this.columns}
                                          className={'c-table'}
                                          keyField={'_id'}
                                          data={filterValues}
                                          noHeader={true}
                                          pagination
                                          paginationDefaultPage={defaultPage}
                                          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                                          paginationPerPage={rowsPerPage}
                                          onChangePage={page => {
                                            this.updateTablePage(
                                              page,
                                              `filter-${this.props.dag.filter.title.replace(' ', '-')}`
                                            )
                                          }}
                                          onChangeRowsPerPage={(rows, page) => {
                                            this.updateTableRows(
                                              page,
                                              rows,
                                              `filter-${this.props.dag.filter.title.replace(' ', '-')}`
                                            )
                                          }}
                                          defaultSortField="name"
                                        />
                                      ) : (
                                        <table className="c-table">
                                          <thead className="c-table__head">
                                            {toDelete === null ? (
                                              <tr className="c-table__row">
                                                <th className="c-table__cell c-table__cell--head">Unique Id</th>
                                                <th className="c-table__cell c-table__cell--head">Title</th>
                                                <th className="c-table__cell c-table__cell--head">Created</th>
                                                <th className="c-table__cell c-table__cell--head u-text-right">
                                                  Actions
                                                </th>
                                              </tr>
                                            ) : (
                                              <tr className="c-table__row">
                                                <th className="c-table__cell c-table__cell--head" colSpan={3}></th>
                                                <th className="c-table__cell c-table__cell--head u-text-right">
                                                  Actions
                                                </th>
                                              </tr>
                                            )}
                                          </thead>
                                          <tbody>
                                            <tr className="c-table__row">
                                              <td className="c-table__cell" colSpan={3}>
                                                Deleting Filter Value will also remove this value from users and dynamic
                                                apps.
                                              </td>
                                              <td className="c-table__cell u-text-right">
                                                <button
                                                  onClick={() => this.setState({ toDelete: null })}
                                                  className={`c-btn ${classes.buttonSecondary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                                >
                                                  <Icon.X size={10} /> Cancel
                                                </button>

                                                <button
                                                  onClick={this.confirmDelete}
                                                  className={`c-btn ${classes.buttonDanger} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                                >
                                                  <Icon.Slash size={10} /> Confirm Delete
                                                </button>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      )}
                                    </div>
                                  )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <AccessDenied props={{ classes, history }} />
          )}
        </div>
      </AdminLayout>
    )
  }
}

ViewFilter.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  getFilter: PropTypes.func.isRequired,
  deleteFilterValue: PropTypes.func,
  resetDagState: PropTypes.func,
  auth: PropTypes.object.isRequired,
  setDataTables: PropTypes.func,
  dataTables: PropTypes.object,
  dag: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  classes: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
  dag: state.dag,
  dataTables: state.dataTables,
})

export default connect(mapStateToProps, {
  logoutUser,
  deleteFilterValue,
  getFilter,
  resetDagState,
  setDataTables,
})(withStyles(styles)(ViewFilter))
